
async function mediaDeviceExists(kind : MediaDeviceKind)
{
    const devices = await navigator.mediaDevices.enumerateDevices();
    let result = false;
    devices.forEach(device => {
        if (device.kind === kind) {
            result = true;
        }
    });
    return result;
}

export {mediaDeviceExists};